export default {
  header: 'Valitse valikko',
  open_now: 'Avoinna nyt',
};
